import { AnalyticsPage, PerformanceTable, SentinelBreakdown, toPerformanceTable } from '@/modules/sentinel-analytics';
import { SENTINEL_TABLE_KEYS } from '@/modules/sentinel-analytics/metric-keys';

export default function PerformanceRoute() {
  return (
    <AnalyticsPage title='Performance' tabs>
      {(query, dimension) => (
        <SentinelBreakdown query={query} keys={SENTINEL_TABLE_KEYS.performance} dimension={dimension} groupBys={{ category: [['category', 'bucket'], ['category', 'subcategory', 'bucket']], channel: [['channel', 'bucket']] }}>
          {([groups, subGroups = []]) => {
            const { rows, subRows, businessAvailable } = toPerformanceTable(groups, dimension, subGroups);
            return (
              <>
                <PerformanceTable nameLabel={dimension === 'channel' ? 'Channel' : 'Category'} rows={rows} subRows={subRows} businessAvailable={businessAvailable} />
                <p className='mt-2 text-xs text-gray-800'>
                  Automation = no Sentinel action · HITL = sent as drafted or only approved · Oversight = refined or corrected. A ticket counts in its heaviest group.
                </p>
              </>
            );
          }}
        </SentinelBreakdown>
      )}
    </AnalyticsPage>
  );
}
